module.exports = __webpack_public_path__ + "static/media/building2.50d47143.png";